import { SUPPORTED_LOCALES } from './locale'
import { useLocale } from './LocaleProvider'

export function LanguageSwitch({ className = '' }) {
  const { locale, setLocale, t } = useLocale()

  return (
    <div
      className={`flex w-fit rounded-lg border border-gray-200 bg-gray-50 p-1 ${className}`}
      role="group"
      aria-label={t('languageSwitcher.ariaLabel')}
    >
      {SUPPORTED_LOCALES.map((option) => (
        <button
          key={option}
          type="button"
          onClick={() => setLocale(option)}
          className={`rounded-md px-3 py-1.5 text-xs font-semibold transition-colors ${
            locale === option
              ? 'bg-white text-brand-700 shadow-sm'
              : 'text-gray-500 hover:text-gray-900'
          }`}
          aria-pressed={locale === option}
          title={t(`languageSwitcher.${option}Title`)}
        >
          {t(`languageSwitcher.${option}Short`)}
        </button>
      ))}
    </div>
  )
}
